import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-h2h as-scrolling as-scrolling__result-popup" }
const _hoisted_2 = { class: "as-h2-title-box" }
const _hoisted_3 = { class: "as-h2-title-box" }

import { ref, computed } from "vue";
import type { IH2h, IMatch } from "~src/interfaces";
import H2hTab from "~src/components/h2h/basketball/H2hTab.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  h2h: IH2h;
  match: IMatch;
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2hList',
  props: {
    h2h: {},
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("vs");

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: "Toàn bộ",
    key: "vs",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const h2hVs = computed(() => {
  return props.h2h.vs;
});

const h2hHome = computed(() => {
  return props.h2h.home;
});

const h2hAway = computed(() => {
  return props.h2h.away;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-parent-h2h as-parent-h2h__item-h-auto as-parent-h2h-${siteName.value}`)
  }, [
    _createVNode(TabsBtn, {
      tabs: tabs.value,
      activeTab: activeTab.value,
      onChange: changeTab,
      isShowBorder: true
    }, null, 8, ["tabs", "activeTab"]),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "as-h2-title-box" }, "Các trận đối đầu", -1)),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hVs.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.competitions,
          match: _ctx.match,
          tab: "all",
          homeTeamId: _ctx.match.home_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value === 'vs']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_2, " Các trận gần nhất: " + _toDisplayString(_ctx.match.home_team.name), 1),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hHome.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.competitions,
          match: _ctx.match,
          tab: "home",
          homeTeamId: _ctx.match.home_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value !== 'away']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, " Các trận gần nhất: " + _toDisplayString(_ctx.match.away_team.name), 1),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hAway.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.competitions,
          match: _ctx.match,
          tab: "away",
          homeTeamId: _ctx.match.away_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value !== 'home']
      ])
    ])
  ], 2))
}
}

})